import { render, staticRenderFns } from "./OrderDishesGroup.vue?vue&type=template&id=37433c07"
import script from "./OrderDishesGroup.vue?vue&type=script&lang=js"
export * from "./OrderDishesGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports